"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOutputDataTapeFailure = exports.isTransformDataTapeFailure = exports.isTransformDataTapeSuccess = exports.isSanitizedTapeFailure = exports.isSanitizedTapeSuccess = exports.isInvalidField = exports.isRequiredBaseFieldConfig = exports.isStringBaseFieldConfig = exports.isPercentageBaseFieldConfig = exports.isIntegerBaseFieldConfig = exports.isFloatBaseFieldConfig = exports.isDateTimeBaseFieldConfig = exports.isDateBaseFieldConfig = exports.isCurrencyBaseFieldConfig = exports.isBooleanBaseFieldConfig = void 0;
const _ = __importStar(require("lodash"));
const isBooleanBaseFieldConfig = (obj) => {
    return (obj && 'externalBooleanTrue' in obj && _.isString(obj.externalBooleanTrue));
};
exports.isBooleanBaseFieldConfig = isBooleanBaseFieldConfig;
const isCurrencyBaseFieldConfig = (obj) => {
    return obj && 'currencyCode' in obj && _.isString(obj.currencyCode);
};
exports.isCurrencyBaseFieldConfig = isCurrencyBaseFieldConfig;
const isDateBaseFieldConfig = (obj) => {
    return (obj && 'externalDateFormat' in obj && _.isString(obj.externalDateFormat));
};
exports.isDateBaseFieldConfig = isDateBaseFieldConfig;
const isDateTimeBaseFieldConfig = (obj) => {
    return (obj &&
        'externalDateTimeFormat' in obj &&
        _.isString(obj.externalDateTimeFormat));
};
exports.isDateTimeBaseFieldConfig = isDateTimeBaseFieldConfig;
const isFloatBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        (obj.type === 'float' || obj.type === 'optionalFloat'));
};
exports.isFloatBaseFieldConfig = isFloatBaseFieldConfig;
const isIntegerBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        (obj.type === 'integer' || obj.type === 'optionalInteger'));
};
exports.isIntegerBaseFieldConfig = isIntegerBaseFieldConfig;
const isPercentageBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        (obj.type === 'percentage' || obj.type === 'optionalPercentage'));
};
exports.isPercentageBaseFieldConfig = isPercentageBaseFieldConfig;
const isStringBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        (obj.type === 'string' || obj.type === 'optionalString'));
};
exports.isStringBaseFieldConfig = isStringBaseFieldConfig;
const isRequiredBaseFieldConfig = (obj) => {
    return (obj &&
        'type' in obj &&
        _.isString(obj.type) &&
        !String(obj.type).startsWith('optional'));
};
exports.isRequiredBaseFieldConfig = isRequiredBaseFieldConfig;
// this typeguard is very generic
// @makarand-errors:TODO - useNoThrow API
const isInvalidField = (obj) => {
    return obj && 'expectedType' in obj && _.isString(obj.expectedType);
};
exports.isInvalidField = isInvalidField;
const isSanitizedTapeSuccess = (obj) => {
    return (obj &&
        'isValid' in obj &&
        'data' in obj &&
        obj.isValid === true &&
        _.isArray(obj.data));
};
exports.isSanitizedTapeSuccess = isSanitizedTapeSuccess;
const isSanitizedTapeFailure = (obj) => {
    return (obj &&
        'isValid' in obj &&
        'errors' in obj &&
        obj.isValid === false &&
        _.isArray(obj.errors));
};
exports.isSanitizedTapeFailure = isSanitizedTapeFailure;
const isTransformDataTapeSuccess = (obj) => {
    return (obj &&
        'isValid' in obj &&
        'data' in obj &&
        obj.isValid === true &&
        'outputBuffer' in obj.data);
};
exports.isTransformDataTapeSuccess = isTransformDataTapeSuccess;
const isTransformDataTapeFailure = (obj) => {
    return (obj &&
        'isValid' in obj &&
        'errors' in obj &&
        obj.isValid === false &&
        _.isArray(obj.errors));
};
exports.isTransformDataTapeFailure = isTransformDataTapeFailure;
const isOutputDataTapeFailure = (obj) => {
    return (obj &&
        'isValid' in obj &&
        'errors' in obj &&
        obj.isValid === false &&
        _.isArray(obj.errors));
};
exports.isOutputDataTapeFailure = isOutputDataTapeFailure;
//# sourceMappingURL=typeguards.js.map